import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { AppExclusiveDealLabel } from 'components/AppExclusiveDealLabel';
import { OfferLogo } from 'components/Offer/Shared/OfferLogo';
import { shouldOfferBeBranded } from 'components/Offer/Shared/utils';
import { SplitBookingBundleType, SplitBookingOfferInfo } from 'components/Offer/types';
import { messages } from 'components/SplitBookings/messages';
import { SearchOffer } from 'modules/sapiSearch/slice';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { Tooltip, TooltipPlacement } from '@daedalus/atlas/Tooltip';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { OfferSecondaryLayoutVariant } from '@daedalus/core/src/offer/types/OfferLayout';
const _exp = /*#__PURE__*/() => Icon;
const InfoIcon = /*#__PURE__*/styled(_exp())({
  name: "InfoIcon",
  class: "ijx7xuc",
  propsAsIs: true
});
interface MainProps {
  isSplitBooking?: false;
  splitBookingType?: never;
  variant: OfferSecondaryLayoutVariant;
  offer: SearchOffer;
  isAppLockedDeal: boolean;
  splitBookingOffers?: never;
  savingsMessage?: never;
  isRequiredOneTimePasswordFlow?: boolean;
}
interface SplitBookingProps {
  isSplitBooking: true;
  splitBookingType: SplitBookingBundleType;
  splitBookingOffers: SplitBookingOfferInfo[];
  variant: OfferSecondaryLayoutVariant;
  savingsMessage: string;
  isAppLockedDeal?: never;
  offer?: never;
  isRequiredOneTimePasswordFlow?: boolean;
}
export const ProviderLogoComponent: React.FC<MainProps | SplitBookingProps> = ({
  offer,
  isSplitBooking,
  splitBookingType,
  isAppLockedDeal,
  splitBookingOffers = [],
  variant,
  savingsMessage = '',
  isRequiredOneTimePasswordFlow
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    brand,
    brandCode,
    brandIsVio
  } = useBrand();
  if (isSplitBooking) {
    const firstOffer = splitBookingOffers[0]?.offer;
    const secondOffer = splitBookingOffers[1]?.offer;
    const isSameProvider = firstOffer?.intermediaryProvider === secondOffer?.intermediaryProvider;
    const isFirstOfferBranded = shouldOfferBeBranded({
      offerIntermediaryProviderCode: firstOffer?.intermediaryProvider,
      bookOnBrand: brand.bookOnBrand,
      brandIsVio
    });
    const isSecondOfferBranded = shouldOfferBeBranded({
      offerIntermediaryProviderCode: secondOffer?.intermediaryProvider,
      bookOnBrand: brand.bookOnBrand,
      brandIsVio
    });
    if (variant !== 'SecondaryDefault' && splitBookingType === 'split_flow') {
      return <Flex.Row alignItems="center">
          <Text variant="bodyXS">{formatMessage(messages.splitBooking)}</Text>
          <Tooltip content={savingsMessage} placement={TooltipPlacement.Bottom}>
            <InfoIcon name="Information" size="sm" />
          </Tooltip>
        </Flex.Row>;
    }

    // Added as part of 70766997-desktop-hotel-card-secondary-offers
    if (variant === 'SecondaryInline') return <OfferLogo offer={firstOffer} isSecondaryInlineOffer providerCodeOverride={isFirstOfferBranded && brandCode} />;
    return <Box height={variant === 'SecondaryDefault' ? '20px' : 'auto'} display="flex" alignItems="center" flexWrap="wrap" gap="s200">
        <OfferLogo offer={firstOffer} variant="iconAndName" size={variant === 'SecondaryWithoutRoomName' ? 'sm' : 'md'} isSplitBooking providerCodeOverride={isFirstOfferBranded && brandCode} />
        {!isSameProvider && <>
            +
            <OfferLogo offer={secondOffer} variant="iconAndName" size={variant === 'SecondaryWithoutRoomName' ? 'sm' : 'md'} isSplitBooking providerCodeOverride={isSecondOfferBranded && brandCode} />
          </>}
      </Box>;
  }
  const {
    intermediaryProvider
  } = offer || {};
  const isBrandedDeal = shouldOfferBeBranded({
    offerIntermediaryProviderCode: intermediaryProvider,
    bookOnBrand: brand.bookOnBrand,
    brandIsVio
  });

  // Added as part of 70766997-desktop-hotel-card-secondary-offers
  if (variant === 'SecondaryInline') return <OfferLogo offer={offer} isSecondaryInlineOffer providerCodeOverride={(isAppLockedDeal || isBrandedDeal) && brandCode} isRequiredOneTimePasswordFlow={isRequiredOneTimePasswordFlow} />;
  return <Flex.Row gap="s200">
      <Box height={variant === 'SecondaryDefault' ? '20px' : 'auto'} display="flex" alignItems="center" flexWrap="wrap" gap="s200">
        <OfferLogo offer={offer} size={variant === 'SecondaryWithoutRoomName' ? 'sm' : 'md'} variant={isAppLockedDeal ? 'icon' : 'iconAndName'} providerCodeOverride={(isAppLockedDeal || isBrandedDeal) && brandCode} isRequiredOneTimePasswordFlow={isRequiredOneTimePasswordFlow} />
      </Box>
      {isAppLockedDeal && <AppExclusiveDealLabel variant="titleS" />}
    </Flex.Row>;
};

require("./ProviderLogoComponent.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProviderLogoComponent.tsx");